import {
  GET_BUSINESSES,
  GET_BUSINESSES_SUCCESS,
  API_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  businesses: [],
}

const BusinessesList = (state = initialState, action) => {
  switch (action.type) {
    case GET_BUSINESSES:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_BUSINESSES_SUCCESS:
      state = {
        ...state,
        businesses: action.payload.businesses,
        loading: false,
        done: true,
      }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default BusinessesList
